import { STORAGE_KEYS } from './Storage';

export const API_CONFIG = {
  BASE_URL: 'https://sahicrm.com/',
  ENDPOINTS: {
    SEND_CHANGE: '/Set.asmx/SendChange',
    GET_DATA: '/GetData.asmx/GetData'
  }
};

export const getLastSyncDT = () => {
  return localStorage.getItem(STORAGE_KEYS.MY_LAST_SYNC);
};

export const setLastSyncDT = (date) => {
  localStorage.setItem(STORAGE_KEYS.MY_LAST_SYNC, date);
};
